import { render, staticRenderFns } from "./OverallWeighin.vue?vue&type=template&id=4436ce90&scoped=true&"
import script from "./OverallWeighin.vue?vue&type=script&lang=js&"
export * from "./OverallWeighin.vue?vue&type=script&lang=js&"
import style0 from "./OverallWeighin.vue?vue&type=style&index=0&id=4436ce90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4436ce90",
  null
  
)

export default component.exports